module.exports = __webpack_public_path__ + "static/media/homem_r1_c3.e09777a3.jpg";